export const HTML_MODAL = 'HTML_MODAL';

export interface IShowHtmlEditorModalAction {
    type: typeof HTML_MODAL;
}

export type HtmlModalActionTypes = IShowHtmlEditorModalAction;
